import { render } from "./property-mortgage-new.vue?vue&type=template&id=01d5af82"
import script from "./property-mortgage-new.js?vue&type=script&lang=js"
export * from "./property-mortgage-new.js?vue&type=script&lang=js"

import "./property-mortgage-new.vue?vue&type=style&index=0&id=01d5af82&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__